export default "__VITE_ASSET__Bs0v9LtC__"